import { NumberInput, NumberInputProps } from 'react-hook-form-mantine';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import React from 'react';
import { FieldValues } from 'react-hook-form';
import { NumberInputWithHashStyles } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityFeatures/NumberInputWithHash/NumberInputWithHash.styles.tsx';

type Props<T extends FieldValues> = NumberInputProps<T>;

export const NumberInputWithHash = <T extends FieldValues>(props: Props<T>) => (
	<NumberInputWithHashStyles>
		<NumberInput
			size="md"
			leftSection={<Icon variant="hash" size="vlg" />}
			hideControls
			className="input"
			{...props}
		/>
	</NumberInputWithHashStyles>
);
